import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para Provincia de Buenos Aires?',
  a: 'Sí, está alineado al diseño curricular de PBA y a los NAP nacionales.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Al instante por mail tras el pago. Acceso a Google Drive.'
}, {
  q: '¿Es editable?',
  a: 'El material se entrega en PDF de alta calidad listo para imprimir, para asegurar el diseño y la estructura pedagógica.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-16 px-4 bg-brand-dark" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <h2 className="text-4xl font-black text-center text-white mb-8 md:mb-10" data-id="element-76">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 md:space-y-4" data-id="element-77">
          {faqs.map((faq, index) => <div key={index} className="border-2 border-white/10 rounded-xl overflow-hidden shadow-sm" data-id="element-78">
              <button className="w-full px-6 py-5 text-left bg-white/5 hover:bg-white/10 transition-colors flex justify-between items-center" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-79">
                <span className="font-bold text-lg text-white pr-4" data-id="element-80">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-brand-orange flex-shrink-0" data-id="element-81" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-82" />}
              </button>

              {openIndex === index && <div className="px-6 py-5 bg-transparent text-gray-300 text-lg leading-relaxed border-t border-white/10" data-id="element-83">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}